// extracted by mini-css-extract-plugin
export default {"reserveSection":"src-modules-session-sales-institution-reservations-reserve-style__reserveSection_CPmdj"};